import React, { forwardRef } from "react";
import { chakra, useMultiStyleConfig } from "@chakra-ui/react";
import { CheckIcon } from "@heroicons/react/24/outline";
const ChakraCheckIcon = chakra(CheckIcon);
export const SelectOption = forwardRef(({ isSelected = false, children, ...props }, ref) => {
    const styles = useMultiStyleConfig("SelectOption");
    return (React.createElement(chakra.div, { ref: ref, __css: styles["option"], "data-highlighted": isSelected ? "true" : undefined, ...props },
        children,
        React.createElement(ChakraCheckIcon, { __css: styles["checkIcon"], "aria-selected": isSelected ? "true" : undefined })));
});
